@if (!embedded) {
  @if (canRenderAppShell) {
    <mat-menu #wellspacesMenu="matMenu">
      <div class="wellspacesMenu">
        @if (teamAdminWellspaceCreationEnabled) {
          <button mat-menu-item (click)="addWellspace()"><mat-icon>add</mat-icon>Add a Wellspace</button>
        }
        @if (wellspaces.length > 0) {
          <div>
            <mat-divider ></mat-divider>
            <span class="wellspacesection">Wellspaces</span><br>
            <input name="wellspacefilter" class="filterinput" matInput [(ngModel)]="wellspaceFilter" (click)="$event.stopPropagation()" (keyup)="applyFilter($event)" placeholder="Filter by...">
            @if (wellspaceFilter) {
              <button matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter($event)">
                <mat-icon>close</mat-icon>
              </button>
            }
            @for (wellspace of filteredWellspaces; track wellspace) {
              <div class="wellspaceitem" (click)="gotoWellspace(wellspace)">
                <button mat-menu-item>{{wellspace.name}}</button>
              </div>
            }
          </div>
        }
      </div>
    </mat-menu>
    @if (ready && !this.router.url.includes('/2fa')) {
      <mat-toolbar
        [ngClass]="{'hidetoolbar': toolbarClass === 'hidetoolbar'}"
        >
        <button mat-icon-button class="example-icon" aria-label="Menu" (click)="toggleNav()">
          <mat-icon>menu</mat-icon>
        </button>
        <div class="largemediaonly topleft">
          <span>{{leftTitle()}}</span>
          <span class="verticaldivider">|</span>
          <button mat-icon-button (click)="navigate('')"><mat-icon class="home">home</mat-icon></button>
        </div>
        @if (!isCustomerSupport && !isPayrollAdminHostMode && !isNativeCompanyManager) {
          <span>{{currentWellspace.role ? 'Admin for': ''}} {{currentWellspace.name}} {{currentWellspace.companyName ? 'in ' + currentWellspace.companyName : ''}}</span>
        }
        @if (isNativeCompanyManager) {
          <span>{{nativeWorkspaceTeamName}}</span>
        }
        @if (isNativeTeamManager && wellspaces.length > 1) {
          <button mat-button [matMenuTriggerFor]="wellspacesMenu" aria-label="Switch Team">
            <mat-icon>swap_horiz</mat-icon> Switch Team
          </button>
        }
        @if (isIntegrationAdmin) {
          <span>{{$safeNavigationMigration(company?.company_type) | titlecase }}{{company ? ':' : ''}} {{company?.name}}</span>
        }
        @if (isPayrollAdminHostMode) {
          <span>{{payrollCompanyName}}</span>
        }
        @if (spinnerLevel > 0) {
          <mat-spinner class="spinner" [diameter]="36"></mat-spinner>
        }
        <span class="spacer"></span>
        @if (isIntegrationAdmin) {
          <div>
            <button class="topbutton" mat-icon-button (click)="actionsClicked()">
              <div class="buttonwrapper">
                <span [matBadge]="approvalCount" matBadgeColor="accent" [matBadgeHidden]="false"></span>
                <mat-icon svgIcon="bell"></mat-icon>
                <span class="iconlabel">Actions</span>
              </div>
            </button>
          </div>
        }
        <div class="infowrapper">
          @if (useSharedAdminShell) {
            @if (brandUrl) {
              <img [src]="brandUrl" class="brandlogo" (error)="onBrandLogoError()">
            }
            <button
              class="shared-admin-user-menu-trigger"
              mat-icon-button
              [matMenuTriggerFor]="sharedAdminUserMenu"
              [attr.aria-label]="currentUserDisplayName ? 'Open account menu for ' + currentUserDisplayName : 'Open account menu'"
              >
              <span class="shared-admin-user-avatar">{{currentUserInitials}}</span>
            </button>
          } @else {
            @if (isPayrollAdminHostMode) {
              @if (brandUrl) {
                <img [src]="brandUrl" class="brandlogo" (error)="onBrandLogoError()">
              }
              <button
                class="payroll-user-menu-trigger"
                mat-icon-button
                [matMenuTriggerFor]="payrollUserMenu"
                [attr.aria-label]="currentUserDisplayName ? 'Open account menu for ' + currentUserDisplayName : 'Open account menu'"
                >
                <span class="payroll-user-avatar">{{currentUserInitials}}</span>
              </button>
            } @else {
              <div class="legacy-user-identity">
                <span class="userinfo">{{currentUserInfo}}</span>
                @if (sensitiveDataAccessPills.length) {
                  <div class="sensitive-data-access-pills" aria-label="Sensitive data access">
                    @for (pill of sensitiveDataAccessPills; track pill) {
                      <span
                        class="sensitive-data-access-pill"
                        [attr.title]="pill.capability"
                      >{{pill.label}}</span>
                    }
                  </div>
                }
              </div>
              @if (brandUrl) {
                <img [src]="brandUrl" class="brandlogo" (error)="onBrandLogoError()">
              }
            }
          }
        </div>
        <mat-menu #payrollUserMenu="matMenu">
          <button mat-menu-item (click)="navigate('profile')">
            <mat-icon>person</mat-icon>
            <span>Edit Profile</span>
          </button>
          <button mat-menu-item (click)="logoutClicked(false)">
            <mat-icon>logout</mat-icon>
            <span>Sign Out</span>
          </button>
        </mat-menu>
        <mat-menu #sharedAdminUserMenu="matMenu">
          <button mat-menu-item (click)="navigate('profile')">
            <mat-icon>person</mat-icon>
            <span>Account Profile</span>
          </button>
          <button mat-menu-item (click)="navigate('2fa/profile')">
            <mat-icon>security</mat-icon>
            <span>2FA</span>
          </button>
          <button mat-menu-item (click)="logoutClicked(false)">
            <mat-icon>logout</mat-icon>
            <span>Sign Out</span>
          </button>
        </mat-menu>
        @if (isTeamAdminOrUnmatched && !isPayrollAdminHostMode && !useSharedAdminShell) {
          <div>
            <button class="topbutton" mat-icon-button (click)="plansClicked()">
              <div class="buttonwrapper">
                <mat-icon svgIcon="plans"></mat-icon>
                <span class="iconlabel">Plans</span>
              </div>
            </button>
            <button class="topbutton" mat-icon-button (click)="notificationsClicked()">
              <div class="buttonwrapper">
                <mat-icon>notifications</mat-icon>
                <span class="iconlabel">Notifications</span>
              </div>
            </button>
            <button class="topbutton" mat-icon-button [matMenuTriggerFor]="wellspacesMenu" >
              <div class="buttonwrapper">
                <mat-icon>grid_view</mat-icon>
                <span class="iconlabel">Wellspaces</span>
              </div>
            </button>
            <button class="topbutton" mat-icon-button (click)="helpClicked()">
              <div class="buttonwrapper">
                <mat-icon>help_outline</mat-icon>
                <span class="iconlabel">Help</span>
              </div>
            </button>
            <button class="topbutton" mat-icon-button (click)="launchClicked()">
              <div class="buttonwrapper">
                <img class="walliticon" src="assets/icons/favicon.png">
                <span class="iconlabel">Launch</span>
              </div>
            </button>
          </div>
        }
        @if (user && user.contact && !useSharedAdminShell) {
          <span>{{user.contact.name || user.contact.email}}</span>
        }
      </mat-toolbar>
    }
    <mat-sidenav-container hasBackdrop="false" autosize="true">
      @if (isLoggedIn && !this.router.url.includes('/2fa')) {
        <mat-sidenav
          [class.sidenav]="!isPayrollAdminHostMode"
          [class.branded-sidenav]="isPayrollAdminHostMode"
          #sidenav
          [mode]="sidenavMode"
          [opened]="sidenavOpened"
          (openedChange)="sidenavOpened = $event">
          <div class="sidenavwrapper">
            <div class="topside">
              <mat-accordion multi>
                @if (canRenderNativeNavigation) {
                  <div>
                    <mat-expansion-panel expanded="true">
                      <mat-expansion-panel-header>
                        <span class="section">NAVIGATION</span>
                      </mat-expansion-panel-header>
                      <button class="leftbutton" [class.leftbutton-active]="isRouteActive('')" mat-icon-button (click)="navigate('')">
                        <mat-icon>home</mat-icon>
                        Home
                      </button>
                      @if (companyOffersAccess.allowedContext$ | async) {
                        <button class="leftbutton" [class.leftbutton-active]="isRouteActive('offers')" mat-icon-button (click)="navigate('offers')">
                          <mat-icon>local_offer</mat-icon>
                          Business Offers
                        </button>
                      }
                      <button class="leftbutton" mat-icon-button (click)="wallitClicked()">
                        <mat-icon>keyboard_return</mat-icon>
                        Back to Wallit
                      </button>
                    </mat-expansion-panel>
                  </div>
                  <div>
                    <mat-expansion-panel expanded="true">
                      <mat-expansion-panel-header>
                        <span class="section">MANAGEMENT</span>
                      </mat-expansion-panel-header>
                      <button class="leftbutton" [class.leftbutton-active]="isNativeTeamManager ? (isRouteActive('my-team') || isRouteActive('managewellspace')) : isRouteActive('payrolladmin/teams')" mat-icon-button (click)="navigate(isNativeTeamManager ? 'my-team' : 'payrolladmin/teams')">
                        <mat-icon>groups</mat-icon>
                        {{ isNativeTeamManager ? 'My Team' : 'Teams' }}
                      </button>
                      @if (canAccessPayrollExpenseApprovals || isNativeTeamManager) {
                        <button class="leftbutton" [disabled]="isNativeTeamManager && !currentWellspace.name" [class.leftbutton-active]="isRouteActive(isNativeTeamManager ? 'purchases' : 'payrolladmin/expense-approvals')" mat-icon-button (click)="navigate(isNativeTeamManager ? 'purchases' : 'payrolladmin/expense-approvals')">
                          <mat-icon>fact_check</mat-icon>
                          <span [matBadge]="approvalCount" matBadgeColor="accent" [matBadgeHidden]="!isNativeTeamManager || approvalCount === 0">Approvals</span>
                        </button>
                      }
                      <button class="leftbutton" [class.leftbutton-active]="isRouteActive('dashboards')" mat-icon-button (click)="navigate('dashboards')">
                        <mat-icon>dashboard</mat-icon>
                        Dashboards
                      </button>
                      <button class="leftbutton" [class.leftbutton-active]="isRouteActive('analytics')" [disabled]="!currentWellspace.name" mat-icon-button (click)="navigate('analytics')">
                        <mat-icon>insights</mat-icon>
                        Analytics
                      </button>
                      @if (nativeCompanyHasBenefits && !isNativeTeamManager) {
                        <button class="leftbutton" [class.leftbutton-active]="isRouteActive('payrolladmin/benefits')" mat-icon-button (click)="navigate('payrolladmin/benefits')">
                          <mat-icon>favorite_border</mat-icon>
                          Benefits
                        </button>
                      }
                      @if (canShowNativeBilling) {
                        <button class="leftbutton" [class.leftbutton-active]="isRouteActive('billing')" mat-icon-button (click)="navigate('billing/stripechargehistory')">
                          <mat-icon>credit_card</mat-icon>
                          <span [matBadge]="badgeCount" matBadgeColor="accent" [matBadgeHidden]="badgeCount === 0">Billing</span>
                        </button>
                      }
                    </mat-expansion-panel>
                  </div>
                  <div>
                    <mat-expansion-panel expanded="true">
                      <mat-expansion-panel-header>
                        <span class="section">RESOURCES</span>
                      </mat-expansion-panel-header>
                      <button class="leftbutton" mat-icon-button (click)="plansClicked()">
                        <mat-icon svgIcon="plans"></mat-icon>
                        Plans & Features
                      </button>
                      <button class="leftbutton" mat-icon-button (click)="helpClicked()">
                        <mat-icon>help_outline</mat-icon>
                        Help Center
                      </button>
                    </mat-expansion-panel>
                  </div>
                }
                @if (canRenderEstablishedNavigation) {
                  @if (!isPayrollAdminHostMode && useSharedAdminShell) {
                    <div>
                      <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                          <span class="section">NAVIGATION</span>
                        </mat-expansion-panel-header>
                        @if (isTeamAdminOrUnmatched) {
                          <button class="leftbutton" mat-icon-button (click)="wallitClicked()">
                            <mat-icon>keyboard_return</mat-icon>
                            Back to Wallit
                          </button>
                        }
                        <button class="leftbutton" [class.leftbutton-active]="isRouteActive('')" mat-icon-button (click)="navigate('')">
                          <mat-icon>home</mat-icon>
                          Home
                        </button>
                      </mat-expansion-panel>
                    </div>
                  }
                  @if (!isPayrollAdminHostMode && !useSharedAdminShell) {
                    <div>
                      <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                          <span class="section">ACCOUNT</span>
                        </mat-expansion-panel-header>
                        @if (isTeamAdminOrUnmatched) {
                          <button class="leftbutton" mat-icon-button (click)="wallitClicked()">
                            <mat-icon>keyboard_return</mat-icon>
                            Back to Wallit
                          </button>
                        }
                        <button class="leftbutton" [class.leftbutton-active]="isRouteActive('')" mat-icon-button (click)="navigate('')">
                          <mat-icon>home</mat-icon>
                          Home
                        </button>
                        @if (!isCustomerSupport) {
                          <button class="leftbutton" [class.leftbutton-active]="isRouteActive('profile')" mat-icon-button (click)="navigate('profile')">
                            <mat-icon>person</mat-icon>
                            Account Profile
                          </button>
                        }
                        @if (!isCustomerSupport) {
                          <button class="leftbutton" [class.leftbutton-active]="isRouteActive('2fa/profile')" mat-icon-button (click)="navigate('2fa/profile')">
                            <mat-icon>security</mat-icon>
                            2FA
                          </button>
                        }
                        <!--
                        <button *ngIf="!isCustomerSupport && !isBrokerAdmin" class="leftbutton" mat-icon-button (click)="navigate('insuranceprofile')">
                          <mat-icon>medical_services</mat-icon>
                          Insurance Profile
                        </button>
                        -->
                        <button class="leftbutton" mat-icon-button (click)="logoutClicked(false)">
                          <mat-icon>logout</mat-icon>
                          Sign Out
                        </button>
                      </mat-expansion-panel>
                    </div>
                  }
                  @if (!isPayrollAdminHostMode && useSharedAdminShell) {
                    <div>
                      <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                          <span class="section">RESOURCES</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="plansClicked()">
                          <mat-icon svgIcon="plans"></mat-icon>
                          Plans & Features
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="helpClicked()">
                          <mat-icon>help_outline</mat-icon>
                          Help Center
                        </button>
                      </mat-expansion-panel>
                    </div>
                  }
                  @if (isSuperAdmin || (roles?.client && !roles?.manager && !roles?.broker && !roles?.agency && !roles?.member && !roles?.supportAdmin && !roles?.supportAgent && !roles?.teamAgent)) {
                    <div>
                      <mat-expansion-panel expanded="true">
                        <mat-expansion-panel-header>
                          <span class="section">BENEFITS ADMINISTRATION</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="navigate('brokeragency/clients/client-census')">
                          <mat-icon>business</mat-icon>
                          Census & Eligibility
                        </button>
                      </mat-expansion-panel>
                    </div>
                  }
                  @if (isBrokerAdmin || isSuperAdmin) {
                    <div>
                      <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                          <span class="section">BROKER & AGENCY</span>
                        </mat-expansion-panel-header>
                        @if (roles?.broker || isSuperAdmin) {
                          <button class="leftbutton" mat-icon-button (click)="navigate('brokeragency/broker/broker-agencies')">
                            <mat-icon>store</mat-icon>
                            Broker
                          </button>
                        }
                        @if (roles?.broker || roles?.agency || isSuperAdmin) {
                          <button class="leftbutton" mat-icon-button (click)="navigate('brokeragency/agency/agency-clients')">
                            <mat-icon>badge</mat-icon>
                            Agency
                          </button>
                        }
                        <button class="leftbutton" mat-icon-button (click)="navigate('brokeragency/clients/client-census')">
                          <mat-icon>business</mat-icon>
                          Clients
                        </button>
                      </mat-expansion-panel>
                    </div>
                  }
                  @if (isSuperAdmin || isFinanceAdmin) {
                    <div>
                      <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                          <span class="section">FINANCE</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="navigate('finance/ledger')">
                          <mat-icon>account_balance</mat-icon>
                          Accounting
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('finance/contracts')">
                          <mat-icon>description</mat-icon>
                          Contracts
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('finance/reports')">
                          <mat-icon>assessment</mat-icon>
                          Reports
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('finance/dwolla-reconciliation')">
                          <mat-icon>account_balance_wallet</mat-icon>
                          Dwolla Reconciliation
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('finance/bank-reconciliation')">
                          <mat-icon>account_balance_wallet</mat-icon>
                          Bank Reconciliation
                        </button>
                        @if (isExactSuperAdmin) {
                          <button class="leftbutton" mat-icon-button (click)="navigate('finance/tango-ledger')">
                            <mat-icon>card_giftcard</mat-icon>
                            Tango Ledger
                          </button>
                        }
                        @if (isExactSuperAdmin) {
                          <button class="leftbutton" mat-icon-button (click)="navigate('finance/connections')">
                            <mat-icon>link</mat-icon>
                            Connections
                          </button>
                        }
                      </mat-expansion-panel>
                    </div>
                  }
                  @if (isCustomerSupport || isSuperAdmin) {
                    <div>
                      <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                          <span class="section">SUPPORT</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="navigate('customersupport/managecustomers')">
                          <mat-icon>person_search</mat-icon>
                          Manage Customers
                        </button>
                        @if (roles?.supportAdmin || isSuperAdmin) {
                          <button class="leftbutton" mat-icon-button (click)="navigate('customersupport/managesupportagents')">
                            <mat-icon>supervisor_account</mat-icon>
                            Manage Agents
                          </button>
                        }
                        @if (roles?.supportAdmin || isSuperAdmin) {
                          <button class="leftbutton" mat-icon-button (click)="navigate('customersupport/reports')">
                            <mat-icon>assessment</mat-icon>
                            Reports
                          </button>
                        }
                      </mat-expansion-panel>
                    </div>
                  }
                  @if (!isPayrollAdminHostMode) {
                    <div>
                      <mat-expansion-panel expanded="true">
                        <mat-expansion-panel-header>
                          <span class="section">ADMINISTRATION</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" [class.leftbutton-active]="isRouteActive('dashboards')" mat-icon-button (click)="navigate('dashboards')">
                          <mat-icon>dashboard</mat-icon>
                          Dashboards
                        </button>
                        @if (isTeamAdminOrUnmatched) {
                          <button class="leftbutton" [class.leftbutton-active]="isRouteActive('analytics')" [disabled]="!currentWellspace.name" mat-icon-button (click)="navigate('analytics')">
                            <mat-icon>insights</mat-icon>
                            Analytics
                          </button>
                        }
                        @if (isTeamAdminOrUnmatched) {
                          <button class="leftbutton" [class.leftbutton-active]="isRouteActive('managewellspace')" [disabled]="!currentWellspace.name" mat-icon-button (click)="navigate('managewellspace/overview/current')">
                            <mat-icon>groups</mat-icon>
                            Manage Your Wellspace
                          </button>
                        }
                        @if (isTeamAdminOrUnmatched && !isTeamAgentSession && !isTeamAgentOnly) {
                          <button class="leftbutton" [class.leftbutton-active]="isRouteActive('purchases')" [disabled]="!currentWellspace.name" mat-icon-button (click)="navigate('purchases')">
                            <mat-icon>receipt</mat-icon>
                            <span [matBadge]="approvalCount" matBadgeColor="accent" [matBadgeHidden]="approvalCount === 0">
                              Approvals
                            </span>
                          </button>
                        }
                        @if (isTeamAdminOrUnmatched && !isTeamAgentSession && !isTeamAgentOnly) {
                          <button class="leftbutton" [class.leftbutton-active]="isRouteActive('billing')" [disabled]="!currentWellspace.name" mat-icon-button (click)="navigate('billing/stripechargehistory')">
                            <mat-icon>credit_card</mat-icon>
                            <span [matBadge]="badgeCount" matBadgeColor="accent" [matBadgeHidden]="badgeCount === 0">Billing</span>
                          </button>
                        }
                      </mat-expansion-panel>
                    </div>
                  }
                  @if (isIntegrationAdmin) {
                    <div>
                      <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                          <span class="section">INSURANCE</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="navigate('insurance/carriers')">
                          <mat-icon>business</mat-icon>
                          Carriers
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('insurance/brokers')">
                          <mat-icon>store</mat-icon>
                          Brokers
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('insurance/employers')">
                          <mat-icon>badge</mat-icon>
                          Employers
                        </button>
                        <mat-divider></mat-divider>
                        <button class="leftbutton" mat-icon-button (click)="navigate('insurance/products')">
                          <mat-icon>receipt_long</mat-icon>
                          Companies
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('insurance/policies')">
                          <mat-icon>policy</mat-icon>
                          Policies
                        </button>
                        <mat-divider></mat-divider>
                        <button class="leftbutton" mat-icon-button (click)="navigate('insurance/users')">
                          <mat-icon>people</mat-icon>
                          Users
                        </button>
                      </mat-expansion-panel>
                      <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                          <span class="section">ADVERTISING</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="navigate('advertising/advertisers')">
                          <mat-icon>corporate_fare</mat-icon>
                          Advertisers
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('advertising/campaigns')">
                          <mat-icon>date_range</mat-icon>
                          Campaigns
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('advertising/ads')">
                          <mat-icon>ad_units</mat-icon>
                          Ads
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('advertising/creatives')">
                          <mat-icon>palette</mat-icon>
                          Creatives
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('advertising/flights')">
                          <mat-icon>flights</mat-icon>
                          Flights
                        </button>
                        <mat-divider></mat-divider>
                        <button class="leftbutton" mat-icon-button (click)="navigate('advertising/impressions')">
                          <mat-icon>visibility</mat-icon>
                          Impressions
                        </button>
                      </mat-expansion-panel>
                      <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                          <span class="section">MEDIA</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="navigate('media/images')">
                          <mat-icon>photo_llibrary</mat-icon>
                          Images
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('media/documents')">
                          <mat-icon>description</mat-icon>
                          Documents
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('media/content')">
                          <mat-icon>web</mat-icon>
                          Content
                        </button>
                      </mat-expansion-panel>
                    </div>
                  }
                  @if (isPayrollAdminHostMode) {
                    <div>
                      <mat-expansion-panel [expanded]="payrollSectionExpanded" (opened)="payrollSectionExpanded = true" (closed)="payrollSectionExpanded = false">
                        <mat-expansion-panel-header>
                          <span class="section">PAYROLL</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="navigate('')">
                          <mat-icon>home</mat-icon>
                          Home
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('payrolladmin/dashboards')">
                          <mat-icon>dashboard</mat-icon>
                          Dashboards
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('payrolladmin/company/company')">
                          <mat-icon>business</mat-icon>
                          Company
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('payrolladmin/teams')">
                          <mat-icon>person_search</mat-icon>
                          Teams
                        </button>
                        @if (canAccessPayrollExpenseApprovals) {
                          <button class="leftbutton" mat-icon-button (click)="navigate('payrolladmin/expense-approvals')">
                            <mat-icon>fact_check</mat-icon>
                            Expense Approvals
                          </button>
                        }
                        <button class="leftbutton" mat-icon-button (click)="navigate('payrolladmin/benefits')">
                          <mat-icon>favorite_border</mat-icon>
                          Benefits
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('payrolladmin/deductions')">
                          <mat-icon>payments</mat-icon>
                          Payroll Deductions
                        </button>
                      </mat-expansion-panel>
                    </div>
                  }
                  @if (!isPayrollAdminHostMode && (roles?.manager || roles?.teamAgent || canShowPayrollAdminNavigation) && (!isCustomerSupport || isSuperAdmin)) {
                    <div>
                      <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                          <span class="section">MANAGERS</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" [class.leftbutton-active]="isRouteActive('products')" mat-icon-button (click)="navigate('products')">
                          <mat-icon>receipt_long</mat-icon>
                          Companies
                        </button>
                        @if (canShowPayrollAdminNavigation) {
                          <button class="leftbutton" mat-icon-button (click)="navigateToPayrollAdmin()">
                            <mat-icon>payments</mat-icon>
                            Payroll
                          </button>
                        }
                      </mat-expansion-panel>
                    </div>
                  }
                  @if (isContentAdmin || isSuperAdmin) {
                    <div class="content-nav-section">
                      <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                          <span class="section">CONTENT</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="navigate('contentadmin/vendors')">
                          <mat-icon>domain</mat-icon>
                          Vendors
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('contentadmin/adminFees')">
                          <mat-icon>price_change</mat-icon>
                          Admin Fees
                        </button>
                        @if (isSuperAdmin) {
                          <button class="leftbutton" mat-icon-button (click)="navigate('superadmin/rewards')">
                            <mat-icon>redeem</mat-icon>
                            Rewards/Snacks
                          </button>
                        }
                        @if (isSuperAdmin) {
                          <button class="leftbutton" mat-icon-button (click)="navigate('vendor-products/stripe-products')">
                            <mat-icon>inventory</mat-icon>
                            Products
                          </button>
                        }
                      </mat-expansion-panel>
                    </div>
                  }
                  @if (isSuperAdmin) {
                    <div>
                      <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                          <span class="section">DATA</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="navigate('superadmin/inbound-file-feeds')">
                          <mat-icon>move_to_inbox</mat-icon>
                          Inbound Feeds
                        </button>
                        <button class="leftbutton" [class.leftbutton-active]="isRouteActive('superadmin/product-click-events')" mat-icon-button (click)="navigate('superadmin/product-click-events')">
                          <mat-icon>ads_click</mat-icon>
                          Product Click Events
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('marketing-campaigns')">
                          <mat-icon>campaign</mat-icon>
                          Marketing
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('payrolladmin/dashboards')">
                          <mat-icon>dashboard</mat-icon>
                          Dashboards
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('payrolladmin/reports')">
                          <mat-icon>insights</mat-icon>
                          Scheduled Reports
                        </button>
                      </mat-expansion-panel>
                    </div>
                  }
                  @if (isSuperAdmin) {
                    <div>
                      <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                          <span class="section">SUPER ADMIN</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" [class.leftbutton-active]="isRouteActive('teampayments')" mat-icon-button (click)="navigate('teampayments')">
                          <mat-icon>grid_view</mat-icon>
                          All Wellspaces
                        </button>
                        <button class="leftbutton" [class.leftbutton-active]="isRouteActive('products')" mat-icon-button (click)="navigate('products')">
                          <mat-icon>receipt_long</mat-icon>
                          Companies
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('vendorgroups')">
                          <mat-icon>supervisor_account</mat-icon>
                          Insurance Groups
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('payrolladmin/payrollvendors')">
                          <mat-icon>domain</mat-icon>
                          Payroll Providers
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('superadmin/users')">
                          <mat-icon>people</mat-icon>
                          Users
                        </button>
                        <button class="leftbutton" [class.leftbutton-active]="isRouteActive('superadmin/sensitive-data-access')" mat-icon-button (click)="navigate('superadmin/sensitive-data-access')">
                          <mat-icon>policy</mat-icon>
                          Sensitive Data Access
                        </button>
                        <!--
                        <button class="leftbutton" mat-icon-button (click)="navigate('provisioning')">
                          <mat-icon>shopping_basket</mat-icon>
                          Provisioning
                        </button>
                        -->
                        @if (checkClientFeaturePermission()) {
                          <button class="leftbutton" mat-icon-button (click)="navigate('clients')">
                            <mat-icon>person</mat-icon>
                            Clients
                          </button>
                        }
                        <!--
                        <button class="leftbutton" mat-icon-button (click)="navigate('externalbrokeradmin')">
                          <mat-icon>ballot</mat-icon>
                          Broker Admin
                        </button>
                        -->
                      </mat-expansion-panel>
                    </div>
                  }
                  @if (isSuperAdmin && isFinanceAdmin) {
                    <div>
                      <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                          <span class="section">FINANCE</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="navigate('finance/ledger')">
                          <mat-icon>account_balance</mat-icon>
                          Accounting
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('finance/contracts')">
                          <mat-icon>description</mat-icon>
                          Contracts
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('finance/reports')">
                          <mat-icon>assessment</mat-icon>
                          Reports
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('finance/dwolla-reconciliation')">
                          <mat-icon>account_balance_wallet</mat-icon>
                          Dwolla Reconciliation
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('finance/bank-reconciliation')">
                          <mat-icon>account_balance_wallet</mat-icon>
                          Bank Reconciliation
                        </button>
                        @if (isExactSuperAdmin) {
                          <button class="leftbutton" mat-icon-button (click)="navigate('finance/tango-ledger')">
                            <mat-icon>card_giftcard</mat-icon>
                            Tango Ledger
                          </button>
                        }
                        @if (isExactSuperAdmin) {
                          <button class="leftbutton" mat-icon-button (click)="navigate('finance/connections')">
                            <mat-icon>link</mat-icon>
                            Connections
                          </button>
                        }
                      </mat-expansion-panel>
                    </div>
                  }
                  @if (isSuperAdmin) {
                    <div>
                      <mat-expansion-panel expanded="false">
                        <mat-expansion-panel-header>
                          <span class="section">SYSTEM</span>
                        </mat-expansion-panel-header>
                        <button class="leftbutton" mat-icon-button (click)="navigate('superadmin/ai-assistant')">
                          <mat-icon>smart_toy</mat-icon>
                          AI Assistant
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('contentadmin/brands')">
                          <mat-icon>domain</mat-icon>
                          Brands
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('superadmin/brand-domains')">
                          <mat-icon>cloud</mat-icon>
                          Brand Domains
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('superadmin/json-config')">
                          <mat-icon>settings</mat-icon>
                          JSON Global Config
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('superadmin/managed-feature-flags')">
                          <mat-icon>toggle_on</mat-icon>
                          Managed Feature Flags
                        </button>
                        @if (isExactSuperAdmin) {
                          <button class="leftbutton" [class.leftbutton-active]="isRouteActive('superadmin/incidents')" mat-icon-button (click)="navigate('superadmin/incidents')">
                            <mat-icon>assignment</mat-icon>
                            Incidents
                          </button>
                        }
                        @if (isExactSuperAdmin) {
                          <button class="leftbutton" [class.leftbutton-active]="isRouteActive('superadmin/observability')" mat-icon-button (click)="navigate('superadmin/observability')">
                            <mat-icon>monitor_heart</mat-icon>
                            Observability
                          </button>
                        }
                        <button class="leftbutton" mat-icon-button (click)="navigate('workflows')">
                          <mat-icon>account_tree</mat-icon>
                          Workflows
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('env-sync')">
                          <mat-icon>sync</mat-icon>
                          Environment Sync
                        </button>
                        <button class="leftbutton" mat-icon-button (click)="navigate('convert-834')">
                          <mat-icon>swap_horiz</mat-icon>
                          Convert 834
                        </button>
                      </mat-expansion-panel>
                    </div>
                  }
                }
                <span class="version">Version {{info}}</span>
              </mat-accordion>
            </div>
            <!--<span class="sidebottom">Made with &hearts; by Wallit</span>-->
          </div>
        </mat-sidenav>
      }
      <mat-sidenav-content [class.shared-admin-sidenav-content]="useSharedAdminShell">
        <div [ngClass]="{'content': !this.router.url.includes('/2fa')}">
          <router-outlet></router-outlet>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  } @else {
    <div class="payroll-theme-loading">
      <mat-spinner [diameter]="42"></mat-spinner>
    </div>
  }
}
@if (embedded) {
  <router-outlet></router-outlet>
}
@if (showLoading) {
  <div class="loading-indicator">
    <mat-spinner [diameter]="50"></mat-spinner>
    <span class="loadingmessage">{{spinnerMessage ? spinnerMessage : 'Wait'}}...</span>
  </div>
}
